import React from "react";

export default function Header() {
  return (
    <header>
      <div className="col-12 text-center p-5">
        <h1>Dictionary App</h1>
        <p>
          Built using React <i className="fa-brands fa-react"></i>
        </p>
      </div>
    </header>
  );
}
